module.exports = __webpack_public_path__ + "img/do.50c030eb.svg";